import { Token } from '@web/walter-lib/api'
import { useEffect } from 'react'
import { regApi, useAccountUserInfo, useKycRequestStatus, useVerificationLevels } from '~api'
import { usePromise } from '~hooks/usePromise'
import { KycStatuses } from '~modals/SettingsModal/tabs/Identity/Level'

interface Props {
    onSuccess?: (result?: Token | undefined) => void
}

export const useData = ({ onSuccess }: Props) => {
    const { data: levelsData, isValidating: levelsLoading } = useVerificationLevels()
    const { data: userAccountData, isValidating: userDataLoading, mutate: mutateUserAccountData } = useAccountUserInfo()
    const { data: kycRequestStatus, isValidating: kycLoading, mutate: mutateKycRequestStatus } = useKycRequestStatus()

    const {
        data,
        send,
        isLoading: isTokenLoading,
    } = usePromise(
        async (nextLevel: number) => {
            const res = await regApi.getAccessToken({ nextLevel })
            return { token: res.token }
        },
        {
            onSuccess,
        }
    )

    const nextLevel = levelsData?.levels?.find(
        level => level.current_level === userAccountData?.verification_level
    )?.next_level

    const requestKycStatus = () => {
        if (nextLevel) {
            send(nextLevel)
        }
    }

    const onApplicantSubmit = async () => {
        await mutateKycRequestStatus()
        await mutateUserAccountData()
    }

    useEffect(() => {
        if (nextLevel && kycRequestStatus?.status === KycStatuses.information_requested) {
            send(nextLevel)
        }
    }, [nextLevel, send, kycRequestStatus?.status])

    return {
        requestKycStatus,
        onApplicantSubmit,
        isTokenLoading,
        nextLevel,
        token: data?.token,
        status: kycRequestStatus?.status,
        isLoading: levelsLoading || userDataLoading || kycLoading,
    }
}
